"use client";
import { cn } from '@/lib/utils';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import Image from 'next/image';
import React, { useState } from 'react'

const WordsFormOurLeaders = () => {

    const [index, setIndex] = useState<number>(0)

    const QUOTES = [
        {
            name: "Er. Pankaj Jalan",
            description: `On behalf of the entire college team, let me congratulate you on your new chapter in life and wish you the best of luck in your future endeavors. Our college is committed and focused on providing high-quality education with the collaboration of the University of Bedfordshire, UK. We proudly announced that the student will have the ability to match the standard of the international level with practical knowledge through an accreditation degree. Alongside this, we have opted to create another signifi cant landmark in the field of education within an international diaspora. As you embark on this exciting journey with us, I encourage you to take advantage of all available resources and opportunities and strive for excellence in all that you do. Along with that, I anticipate making the most of your time in order to make your dreams a reality. Also, if you need any kind of help with your professional development, you can always reach out to me.`,
            image: '/img/leaders/image2.png',
            position: 'Chairman LBEF Group of Institute'
        },
        {
            name: "Er. Prakash Kumar Kejriwal",
            description: `At the outset, let me take this opportunity to introduce PCPS College and delve briefly on the requisite for its inception. The establishment of PCPS College is to provide the education that meets global standards and to execute our dreams we collaborate with the UK university in Nepal. We believe that acquiring the certificate is not enough on today's date, expertise is also a must for the self-marketing of the students in the global arena. With this vision, we strive to provide our youth with the best preparation for careers and life after graduation. We strongly believe in the adage, "Education is for life, not just for a living," and we strive to instill in our students a love of learning that will include the knowledge and understanding they will need to make a positive contribution to the communities in which they live and work. We are proud of our academic partnership with the University of Bedfordshire, which will guide and support us in this endeavor. Finally, I'd like to welcome all aspiring students to PCPS. I'd like to invite you to participate.`,
            image: '/img/leaders/image1.png',
            position: 'Executive Director'
        },
        {
            name: "Rebecca Bunting",
            image: "/img/leaders/rebecca.webp",
            position: "Vice-Chancellor (UoB)",
            description: `As Vice-Chancellor, I want to say thank you for considering the University of Bedfordshire for your studies. We pride ourselves on being a global community where international students are truly welcome. Not only do we attract international students from all over the world, but staff members too, with over 120 countries represented in our staff and student body. The University of Bedfordshire is the place to be if you want to grow not only academically, but socially too, with friendships built on our campuses often lasting a lifetime. Our record of nurturing the talent of the future dates back more than 100 years, but that's not to say we are stuck in the past! Based at a number of locations in and around Bedfordshire, United Kingdom, we are a modern and dynamic university with a strong track record of transforming the lives and career prospects of our students. Our professional, experienced, efficient, and caring staff in the International Office are always ready and willing to help and support you from your enquiry to your graduation and beyond! I very much look forward to welcoming you to the University.`
        }
    ]

    return (
        <section

            /*  className={cn(
                 // `mt-[25px]`,
                 // `md:pl-[3.1875rem] md:pr-[3.125rem] `,
                 `xl:float-none xl:max-w-[95%] xl:w-[65.625rem] xl:m-[2.5rem_auto_5rem]`,
                 `md:max-w-[41.6875rem] md:min-h-[0px] md:m-[1.875rem_0px]`,
                 `clear-both flex flex-col float-left w-full overflow-hidden`,
                 `px-[1.25rem]`
             )} */
            className={cn(
                `p-0`,
                `2xl:mb-[4.3125rem] xl:mb-[4.3125rem]`,
                `md:mb-[3.75rem] md:scroll-mt-40`,
                `w-full max-w-[90rem] m-[0_auto] clear-both mb-8 block scroll-mt-20`
            )}

        >
            <header
                className={`overflow-hidden mt-0 mb-[2.0625rem] max-w-full clear-both table 
        m-[0_auto_1.3125rem] relative w-full z-[1]
        `}
            >
                {/* <h2 className="font-bold text-[1.75rem] md:text-[3.25rem] m-0 text-center leading-tight">
                    Words From Our Leaders
                </h2> */}
                <h2 className={cn(
                    `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                       md:mx-auto md:w-full [word-wrap:break-word] xl:text-[1.75rem] 
                       xl:leading-[2.5rem] md:text-[1.625rem] md:leading-[2.1875rem]
                        md:mb-4 
                       md:clear-none 
                       mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem] clear-both font-bold`
                )}>
                    Words From Our Leaders
                </h2>
            </header>


            {/* {
                            QUOTES.map((quote, idx) => {
                                return <div
                                    key={quote.name.toLocaleLowerCase()}
                                    className={cn(
                                        `xl:min-w-[870px] md:border-b md:border-b-[#939393] md:min-w-[668px] md:flex-col md:justify-between min-w-[280px] overflow-hidden pb-[40px]`,
                                        {
                                            'h-fit md:flex': idx === index,
                                            'hidden': idx !== index
                                        }
                                    )}>

                                    <div className={cn(
                                        `md:self-center`
                                    )}>

                                        <div
                                            className={cn(
                                                `xl:box-content`,
                                                `md:px-[3.625rem] md:max-w-[43.125rem] md:box-border mx-auto w-full`,
                                                `relative z-0`
                                            )}
                                        >

                                            <svg
                                                className={cn(
                                                    `xl:mt-[14.4375rem] xl:w-[5.625rem] xl:h-[4.3125rem]`,
                                                    `md:mt-[14.8125rem] md:w-[5rem] md:h-[3.9375rem]`,
                                                    `mt-[8.8125rem] w-[3.3125rem] h-[2.6875rem]`
                                                )}
                                                aria-hidden="true"
                                                focusable="false"
                                                width="90px"
                                                height="69px"
                                                viewBox="0 0 90 69"
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                            >
                                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g transform="translate(-262.000000, -371.000000)" fill="#000">
                                                        <g transform="translate(81.000000, 200.000000)">
                                                            <g transform="translate(0.000000, 171.000000)">
                                                                <path d="M221.197577,7.9054774 C216.942406,10.2175654 213.502108,12.2085002 210.876577,13.8783415 C208.251047,15.5481828 205.580288,17.7531966 202.864222,20.4934491 C200.329227,23.0624357 198.382743,25.7598313 197.02471,28.5857166 C195.666677,31.4116019 194.716068,35.0509451 194.172854,39.5038553 L200.69138,39.5038553 C206.304584,39.5038553 210.718125,40.8097373 213.932136,43.4215404 C217.146148,46.0333435 218.753129,49.8653577 218.753129,54.9176982 C218.753129,58.5142795 217.327216,61.87532 214.475347,65.0009204 C211.623477,68.1265208 207.707874,69.6892976 202.72842,69.6892976 C194.942364,69.6892976 189.374512,67.2702048 186.024697,62.4319466 C182.674882,57.5936884 181,51.2355418 181,43.357316 C181,37.7911783 182.267478,32.7175057 184.802473,28.1361462 C187.337468,23.5547866 190.41563,19.4658775 194.037052,15.8692962 C197.749009,12.187082 201.687245,9.06152846 205.85188,6.4925418 C210.016515,3.92355514 213.50208,1.82558084 216.308682,0.198555957 L221.197577,7.9054774 Z M271.444547,7.9054774 C267.189377,10.2175654 263.749078,12.2085002 261.123548,13.8783415 C258.498017,15.5481828 255.827259,17.7531966 253.111193,20.4934491 C250.485662,23.1480686 248.516544,25.8668721 247.203779,28.6499409 C245.891014,31.4330098 244.963038,35.0509451 244.419825,39.5038553 L250.938351,39.5038553 C256.551554,39.5038553 260.965095,40.8097373 264.179107,43.4215404 C267.393118,46.0333435 269.0001,49.8653577 269.0001,54.9176982 C269.0001,58.5142795 267.574187,61.87532 264.722317,65.0009204 C261.870448,68.1265208 257.954845,69.6892976 252.97539,69.6892976 C245.189334,69.6892976 239.621482,67.2702048 236.271668,62.4319466 C232.921853,57.5936884 231.246971,51.2355418 231.246971,43.357316 C231.246971,37.7911783 232.514449,32.7175057 235.049444,28.1361462 C237.584439,23.5547866 240.662601,19.4658775 244.284022,15.8692962 C247.995979,12.187082 251.934216,9.06152846 256.098851,6.4925418 C260.263485,3.92355514 263.749051,1.82558084 266.555653,0.198555957 L271.444547,7.9054774 Z"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <Image
                                                alt={quote.name}
                                                src={quote.image}
                                                width={230}
                                                height={230}
                                                sizes="
    (max-width: 767px) 115px,
    (max-width: 1209px) 164px,
    230px
  "
                                                className={cn(
                                                    "rounded-full object-cover block",
                                                    "w-[115px] h-[115px]",          // mobile
                                                    "md:w-[164px] md:h-[164px]",    // tablet
                                                    "xl:w-[230px] xl:h-[230px]"     // desktop
                                                    ,
                                                    {
                                                        "object-center": idx == 0,
                                                        "object-top": idx == 1,
                                                    }
                                                )}
                                            />

                                        </div>

                                        <blockquote
                                            className={cn(
                                                "xl:text-[18px] xl:leading-[28px]",
                                                "md:text-[14px] md:leading-[22px] md:block",
                                                "text-[12px] not-italic leading-[20px] m-[0_0_21px]"
                                            )}
                                        >
                                            {quote.description && quote.description.trim().length > 0 ? (
                                                <>{quote.description}</>
                                            ) : (
                                                <span className="not-italic text-gray-500">No words yet.</span>
                                            )}
                                        </blockquote>


                                        <span className={cn(
                                            `md:text-base md:leading-[24px] md:block `,
                                            `text-sm leading-[21px]`
                                        )}>
                                            <span className={cn(
                                                `font-bold`
                                            )}>{quote.name}</span>
                                            <span className={cn(
                                                ``
                                            )}>
                                                <p className={cn(
                                                    `xl:mb-[1.5rem]`,
                                                    `md:mb-[1.9375rem] md:text-base md:leading-8`,
                                                    `text-[0.875rem] leading-[1.75rem] mb-[1.75rem] mt-0`
                                                )}>{quote.position}</p>
                                            </span>
                                        </span>

                                    </div>

                                </div>
                            })
                        } */}
            {
                QUOTES.map((quote, idx) => {
                    return (
                        <div
                            key={quote.name.toLocaleLowerCase()}
                            className={cn(
                                `xl:box-content`,
                                `md:px-[3.625rem] md:max-w-[43.125rem] md:box-border mx-auto w-full`,
                                `relative z-0`,
                                {
                                    'block': idx === index,
                                    'hidden': idx !== index
                                }
                            )
                            }
                        >

                            <svg
                                className={cn(
                                    `xl:mt-[14.4375rem] xl:w-[5.625rem] xl:h-[4.3125rem]`,
                                    `md:mt-[14.8125rem] md:w-[5rem] md:h-[3.9375rem]`,
                                    `mt-[8.8125rem] w-[3.3125rem] h-[2.6875rem]`
                                )}
                                aria-hidden="true"
                                focusable="false"
                                width="90px"
                                height="69px"
                                viewBox="0 0 90 69"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g transform="translate(-262.000000, -371.000000)" fill="#000">
                                        <g transform="translate(81.000000, 200.000000)">
                                            <g transform="translate(0.000000, 171.000000)">
                                                <path d="M221.197577,7.9054774 C216.942406,10.2175654 213.502108,12.2085002 210.876577,13.8783415 C208.251047,15.5481828 205.580288,17.7531966 202.864222,20.4934491 C200.329227,23.0624357 198.382743,25.7598313 197.02471,28.5857166 C195.666677,31.4116019 194.716068,35.0509451 194.172854,39.5038553 L200.69138,39.5038553 C206.304584,39.5038553 210.718125,40.8097373 213.932136,43.4215404 C217.146148,46.0333435 218.753129,49.8653577 218.753129,54.9176982 C218.753129,58.5142795 217.327216,61.87532 214.475347,65.0009204 C211.623477,68.1265208 207.707874,69.6892976 202.72842,69.6892976 C194.942364,69.6892976 189.374512,67.2702048 186.024697,62.4319466 C182.674882,57.5936884 181,51.2355418 181,43.357316 C181,37.7911783 182.267478,32.7175057 184.802473,28.1361462 C187.337468,23.5547866 190.41563,19.4658775 194.037052,15.8692962 C197.749009,12.187082 201.687245,9.06152846 205.85188,6.4925418 C210.016515,3.92355514 213.50208,1.82558084 216.308682,0.198555957 L221.197577,7.9054774 Z M271.444547,7.9054774 C267.189377,10.2175654 263.749078,12.2085002 261.123548,13.8783415 C258.498017,15.5481828 255.827259,17.7531966 253.111193,20.4934491 C250.485662,23.1480686 248.516544,25.8668721 247.203779,28.6499409 C245.891014,31.4330098 244.963038,35.0509451 244.419825,39.5038553 L250.938351,39.5038553 C256.551554,39.5038553 260.965095,40.8097373 264.179107,43.4215404 C267.393118,46.0333435 269.0001,49.8653577 269.0001,54.9176982 C269.0001,58.5142795 267.574187,61.87532 264.722317,65.0009204 C261.870448,68.1265208 257.954845,69.6892976 252.97539,69.6892976 C245.189334,69.6892976 239.621482,67.2702048 236.271668,62.4319466 C232.921853,57.5936884 231.246971,51.2355418 231.246971,43.357316 C231.246971,37.7911783 232.514449,32.7175057 235.049444,28.1361462 C237.584439,23.5547866 240.662601,19.4658775 244.284022,15.8692962 C247.995979,12.187082 251.934216,9.06152846 256.098851,6.4925418 C260.263485,3.92355514 263.749051,1.82558084 266.555653,0.198555957 L271.444547,7.9054774 Z"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <Image
                                alt={quote.name}
                                src={quote.image}
                                width={184}
                                height={184}
                                /*  sizes="
     (max-width: 767px) 115px,
     (max-width: 1209px) 164px,
     230px
   " */
                                className={cn(
                                    /*  "rounded-full object-cover block",
                                     "w-[115px] h-[115px]",          // mobile
                                     "md:w-[164px] md:h-[164px]",    // tablet
                                     "xl:w-[230px] xl:h-[230px]"     // desktop */
                                    `xl:ml-[12.1875rem] md:size-[18.75rem] md:mt-[-18.75rem] md:ml-[7.875rem] w-[11.5rem] h-[11.5rem]
                                     rounded-full object-cover 
                                    m-[-11.5rem_auto_auto_3rem]
                                    `
                                    ,
                                    {
                                        "object-center": idx == 0,
                                        "object-top": idx == 1,
                                    }
                                )}
                            />
                            <span className={cn(
                                `md:text-base md:leading-[24px] md:block md:mt-[1.875rem] md:mb-[1.25rem]`,
                                `text-sm leading-[21px] mb-[1.25rem] mt-[1.3125rem]`
                            )}>
                                {/* <span className={cn(
                                    `font-bold`
                                )}>{quote.name}</span>
                                <span className={cn(
                                    ``
                                )}>
                                    <p className={cn(
                                        `xl:mb-[1.5rem]`,
                                        `md:mb-[1.9375rem] md:text-base md:leading-8`,
                                        `text-[0.875rem] leading-[1.75rem] mb-[1.75rem] mt-0`
                                    )}>{quote.position}</p>
                                </span> */}
                                <strong>{quote.name}</strong> | {quote.position}

                            </span>

                            <blockquote
                                className={cn(
                                    /*   "xl:text-[16px] xl:leading-[28px]",
                                      "md:text-[12px] md:leading-[22px] md:block",
                                      "text-[11px] not-italic leading-[20px] m-[0_0_21px]" */
                                    "md:text-base md:leading-8 md:block",
                                    "text-[0.875rem] not-italic leading-[1.75rem] m-[0_0_21px]"
                                )}
                            >
                                {quote.description && quote.description.trim().length > 0 ? (
                                    <>{quote.description}</>
                                ) : (
                                    <span className="not-italic text-gray-500">No words yet.</span>
                                )}
                            </blockquote>

                        </div>

                    )
                }
                )
            }


            <div className={cn(
                `md:border-t md:border-t-[#939393]`,
                `md:max-w-[43.125rem] md:box-border mx-auto w-full`,
            )}>
                <div className={cn(
                    `md:w-[170px]`,
                    `bg-white gap-x-[17px] flex text-base [justify-content:left] leading-[16px] relative top-[-10px]`
                )}>
                    <button
                        className={cn(
                            `bg-none cursor-pointer border-none`,
                            `before:content-[url("/svgs/longarrowleft-red.svg")]`
                        )}
                        onClick={() => {
                            setIndex(pre => Math.max(pre - 1, 0))
                        }}
                        disabled={index === 0}
                        aria-label="Previous leader"
                    />
                    <div className={cn(
                        `m-[0_-14px_0_-10px]`
                    )}>
                        <span className={cn(
                            `font-bold inline-block m-[0_2px]`
                        )}>{index + 1}</span>
                        /
                        <span className={cn(
                            `inline-block m-[0_2px]`
                        )}>{QUOTES.length}</span>
                    </div>

                    <button
                        className={cn(
                            `bg-none cursor-pointer border-none`,
                            `before:content-[url("/svgs/longarrowright-red.svg")]`
                        )}
                        onClick={() => {
                            setIndex(pre => Math.min(pre + 1, QUOTES.length - 1))
                        }}
                        disabled={index === QUOTES.length - 1}
                        aria-label="Next leader"
                    />
                </div>
            </div>

        </section >
    )
}

export default WordsFormOurLeaders